import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "row mb-40" }
const _hoisted_2 = { class: "col-xxl-10 col-lg-8 pe-xxl-8" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  key: 0,
  class: "col-12"
}
const _hoisted_5 = { class: "promotion-lock-card mb-25" }
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = { class: "form-group mb-25 position-relative" }
const _hoisted_8 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_9 = { class: "input-group" }
const _hoisted_10 = ["placeholder", "value"]
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "form-group mb-25 position-relative" }
const _hoisted_14 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_15 = { class: "input-group" }
const _hoisted_16 = ["placeholder", "value", "disabled"]
const _hoisted_17 = ["value", "disabled"]
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = { class: "form-group mb-25 position-relative" }
const _hoisted_20 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_21 = { class: "input-group" }
const _hoisted_22 = ["placeholder", "value"]
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "form-group mb-25" }
const _hoisted_25 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_26 = { value: "pending" }
const _hoisted_27 = { value: "sent" }
const _hoisted_28 = { value: "completed" }
const _hoisted_29 = { class: "col-md-6" }
const _hoisted_30 = { class: "form-group mb-25" }
const _hoisted_31 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_32 = { class: "input-group" }
const _hoisted_33 = ["placeholder"]
const _hoisted_34 = { class: "col-md-6" }
const _hoisted_35 = { class: "form-group mb-25" }
const _hoisted_36 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_37 = { value: null }
const _hoisted_38 = ["value"]
const _hoisted_39 = { class: "col-md-6" }
const _hoisted_40 = { class: "form-group mb-25" }
const _hoisted_41 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_42 = ["placeholder"]
const _hoisted_43 = { class: "col-xxl-2 col-lg-4" }
const _hoisted_44 = { class: "card border-0 rounded-1 w-xxl-5 pt-12 pb-12 mb-md-25" }
const _hoisted_45 = { class: "table style-two" }
const _hoisted_46 = {
  scope: "row",
  class: "fs-14 text-title lh-1 ls-1 fw-normal"
}
const _hoisted_47 = { class: "fs-14 fw-semibold lh-1 text-optional text-end" }
const _hoisted_48 = {
  scope: "row",
  class: "fs-14 text-title lh-1 ls-1 fw-normal"
}
const _hoisted_49 = { class: "fs-14 fw-semibold lh-1 text-optional text-end" }
const _hoisted_50 = {
  scope: "row",
  class: "fs-14 text-title lh-1 ls-1 fw-normal"
}
const _hoisted_51 = { class: "fs-14 fw-semibold lh-1 text-optional text-end" }
const _hoisted_52 = {
  scope: "row",
  class: "fs-14 text-title lh-1 ls-1 fw-semibold"
}
const _hoisted_53 = { class: "fs-14 fw-bold lh-1 text-purple text-end" }
const _hoisted_54 = { key: 0 }
const _hoisted_55 = {
  scope: "row",
  class: "fs-14 text-title lh-1 ls-1 fw-normal"
}
const _hoisted_56 = { class: "fs-14 fw-semibold lh-1 text-optional text-end" }
const _hoisted_57 = { key: 1 }
const _hoisted_58 = {
  scope: "row",
  class: "fs-14 text-title lh-1 ls-1 fw-normal"
}
const _hoisted_59 = { class: "fs-14 fw-semibold lh-1 text-optional text-end" }
const _hoisted_60 = { class: "col-12" }
const _hoisted_61 = { class: "form-group mb-25" }
const _hoisted_62 = { class: "d-block fs-14 text-black mb-2" }
const _hoisted_63 = ["placeholder"]
const _hoisted_64 = { class: "d-flex justify-content-end" }
const _hoisted_65 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.stateStore.activePromotion)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", null, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.stateStore.activePromotion.name), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.stateStore.activePromotion.customer_name
                    ? _ctx.$t("sales_page.promotion_auto_applies_for_customer", {
                        value: _ctx.promotionValueLabel,
                        customer: _ctx.stateStore.activePromotion.customer_name,
                      })
                    : _ctx.$t("sales_page.promotion_auto_applies_matching_customers", {
                        value: _ctx.promotionValueLabel,
                      })), 1)
                ]),
                _createElementVNode("small", null, _toDisplayString(_ctx.$t("sales_page.promotion_disable_hint")), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("sales_page.order_tax")), 1),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("input", {
                type: "number",
                class: "form-control shadow-none fs-14 bg-white rounded-start text-title",
                placeholder: _ctx.$t('sales_page.zero'),
                value: _ctx.stateStore.orderTax,
                onInput: _cache[0] || (_cache[0] = (e) => _ctx.stateStore.setOrderTax(Number((e.target as HTMLInputElement).value), _ctx.stateStore.orderTaxType))
              }, null, 40, _hoisted_10),
              _createElementVNode("select", {
                class: "form-select shadow-none fs-14 bg-light text-title",
                style: {"max-width":"70px"},
                value: _ctx.stateStore.orderTaxType,
                onChange: _cache[1] || (_cache[1] = (e) => _ctx.stateStore.setOrderTax(_ctx.stateStore.orderTax, (e.target as HTMLSelectElement).value as 'fixed' | 'percentage'))
              }, [...(_cache[11] || (_cache[11] = [
                _createElementVNode("option", { value: "fixed" }, "$", -1),
                _createElementVNode("option", { value: "percentage" }, "%", -1)
              ]))], 40, _hoisted_11)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("sales_page.order_discount")), 1),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("input", {
                type: "number",
                class: "form-control shadow-none fs-14 bg-white rounded-start text-title",
                placeholder: _ctx.$t('sales_page.zero'),
                value: _ctx.stateStore.orderDiscount,
                disabled: !!_ctx.stateStore.activePromotion,
                onInput: _cache[2] || (_cache[2] = (e) => _ctx.stateStore.setOrderDiscount(Number((e.target as HTMLInputElement).value), _ctx.stateStore.orderDiscountType))
              }, null, 40, _hoisted_16),
              _createElementVNode("select", {
                class: "form-select shadow-none fs-14 bg-light text-title",
                style: {"max-width":"70px"},
                value: _ctx.stateStore.orderDiscountType,
                disabled: !!_ctx.stateStore.activePromotion,
                onChange: _cache[3] || (_cache[3] = (e) => _ctx.stateStore.setOrderDiscount(_ctx.stateStore.orderDiscount, (e.target as HTMLSelectElement).value as 'fixed' | 'percentage'))
              }, [...(_cache[12] || (_cache[12] = [
                _createElementVNode("option", { value: "fixed" }, "$", -1),
                _createElementVNode("option", { value: "percentage" }, "%", -1)
              ]))], 40, _hoisted_17)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("sales_page.shipping_cost")), 1),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("input", {
                type: "number",
                class: "form-control shadow-none fs-14 bg-white rounded-start text-title",
                placeholder: _ctx.$t('sales_page.zero'),
                value: _ctx.stateStore.shippingCost,
                onInput: _cache[4] || (_cache[4] = (e) => _ctx.stateStore.setShippingCost(Number((e.target as HTMLInputElement).value)))
              }, null, 40, _hoisted_22),
              _cache[13] || (_cache[13] = _createElementVNode("span", { class: "input-group-text bg-light border-0 text-title" }, "$", -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t("sales_page.status")), 1),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.saleStatus) = $event)),
              class: "bg-white border-0 rounded-1 fs-14 text-optional w-100 h-55 px-3"
            }, [
              _createElementVNode("option", _hoisted_26, _toDisplayString(_ctx.$t("sales_page.status_pending")), 1),
              _createElementVNode("option", _hoisted_27, _toDisplayString(_ctx.$t("sales_page.status_sent")), 1),
              _createElementVNode("option", _hoisted_28, _toDisplayString(_ctx.$t("sales_page.status_completed")), 1)
            ], 512), [
              [_vModelSelect, _ctx.saleStatus]
            ])
          ])
        ]),
        (!_ctx.isEditMode)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.$t("sales_page.payment_amount")), 1),
                  _createElementVNode("div", _hoisted_32, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.paymentAmount) = $event)),
                      type: "number",
                      min: "0",
                      step: "0.01",
                      class: "form-control shadow-none fs-14 bg-white rounded-start text-title",
                      placeholder: _ctx.$t('sales_page.zero')
                    }, null, 8, _hoisted_33), [
                      [
                        _vModelText,
                        _ctx.paymentAmount,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    _cache[14] || (_cache[14] = _createElementVNode("span", { class: "input-group-text bg-light border-0 text-title" }, "$", -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t("sales_page.payment_method")), 1),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.paymentMethodId) = $event)),
                    class: "bg-white border-0 rounded-1 fs-14 text-optional w-100 h-55 px-3"
                  }, [
                    _createElementVNode("option", _hoisted_37, _toDisplayString(_ctx.$t("sales_page.select_payment_method")), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentMethods, (method) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: method.id,
                        value: method.id
                      }, _toDisplayString(method.name), 9, _hoisted_38))
                    }), 128))
                  ], 512), [
                    [
                      _vModelSelect,
                      _ctx.paymentMethodId,
                      void 0,
                      { number: true }
                    ]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.$t("sales_page.paid_by")), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.paidBy) = $event)),
                    type: "text",
                    class: "w-100 d-block shadow-none fs-14 bg-white rounded-1 text-title",
                    placeholder: _ctx.$t('sales_page.paid_by_placeholder')
                  }, null, 8, _hoisted_42), [
                    [_vModelText, _ctx.paidBy]
                  ])
                ])
              ])
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_43, [
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("table", _hoisted_45, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_46, _toDisplayString(_ctx.$t("sales_page.order_tax")) + " : ", 1),
              _createElementVNode("td", _hoisted_47, " $" + _toDisplayString(_ctx.calculatedTax.toFixed(2)), 1)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_48, _toDisplayString(_ctx.$t("sales_page.discount")) + " : ", 1),
              _createElementVNode("td", _hoisted_49, " $" + _toDisplayString(_ctx.calculatedDiscount.toFixed(2)), 1)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_50, _toDisplayString(_ctx.$t("sales_page.shipping")) + " : ", 1),
              _createElementVNode("td", _hoisted_51, " $" + _toDisplayString(_ctx.stateStore.shippingCost.toFixed(2)), 1)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_52, _toDisplayString(_ctx.$t("sales_page.grand_total")) + " : ", 1),
              _createElementVNode("td", _hoisted_53, "$" + _toDisplayString(_ctx.grandTotal.toFixed(2)), 1)
            ]),
            (!_ctx.isEditMode)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_54, [
                  _createElementVNode("th", _hoisted_55, _toDisplayString(_ctx.$t("sales_page.paid")) + " : ", 1),
                  _createElementVNode("td", _hoisted_56, " $" + _toDisplayString(_ctx.paymentAmount.toFixed(2)), 1)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.isEditMode)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_57, [
                  _createElementVNode("th", _hoisted_58, _toDisplayString(_ctx.$t("sales_page.due")) + " : ", 1),
                  _createElementVNode("td", _hoisted_59, " $" + _toDisplayString(_ctx.balanceDue.toFixed(2)), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_60, [
      _createElementVNode("div", _hoisted_61, [
        _createElementVNode("label", _hoisted_62, _toDisplayString(_ctx.$t("sales_page.notes")), 1),
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.note) = $event)),
          cols: "30",
          rows: "10",
          placeholder: _ctx.$t('sales_page.add_note'),
          class: "d-block w-100 bg-white border-0 rounded-1 resize-none fs-14 text-title"
        }, null, 8, _hoisted_63), [
          [_vModelText, _ctx.note]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_64, [
      _withDirectives((_openBlock(), _createElementBlock("button", {
        class: "btn btn-primary fs-16 fw-medium text-white px-30 py-15",
        type: "button",
        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.submitSale && _ctx.submitSale(...args))),
        disabled: _ctx.isSubmitting
      }, [
        _createTextVNode(_toDisplayString(_ctx.isSubmitting ? _ctx.$t("sales_page.submitting") : _ctx.isEditMode ? _ctx.$t("sales_page.update_sale") : _ctx.$t("sales_page.submit_sale")), 1)
      ], 8, _hoisted_65)), [
        [_directive_permission, _ctx.isEditMode ? 'sale_update' : 'sale_create']
      ])
    ])
  ]))
}